{
    "webshop_offer_voucher_correctCode": "Gyldig kode",
    "webShop_howToFindId_desc": "I spillerprofilen din finner du ID-en din, og du kan kopiere den derfra.",
    "webShop_howToFindId_link": "Hvor finner jeg min personlige ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Feil kode",
    "webshop_offer_voucher_enterYourCode": "Skriv inn din personlige ID",
    "webShop_unexpectedError_desc": "Det har oppstått en uventet feil. Prøv igjen senere.",
    "webShop_accountBanned_desc": "Kontoen er utestengt!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Bruksvilkår",
    "webshop_purchase_privacyPolicy": "Retningslinjer for personvern",
    "webshop_legal_1": "Juridisk",
    "webshop_support_1": "Kundestøtte",
    "mbs_access_welcome_desc": "Velkommen, {0}",
    "btn_login": "Logg inn",
    "mbs_access_error_sessionExpired_desc": "Økten har utløpt. Skriv inn konto-ID manuelt."
}
